<template>
  <div>
    <el-row style="height: 40px">
      <el-col :span="2"><el-tag type="info">发货日志</el-tag></el-col>
      <el-col :span="7">
        订单号：<el-input v-model="tid" size="small" type="text"  style="width:200px"></el-input>
        <el-button type="primary" size="mini" @click="getMemoLog">搜索</el-button>
      </el-col>
      <el-col :span="2"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table border :data="memoData" :header-cell-style="{background:'#F2F6FC',color:'#000'}">
          <el-table-column  label="ID"
                            type="index"
                            :index="indexMethod">
          </el-table-column>
          <el-table-column  prop="tid" label="订单号" width="200px"></el-table-column>
          <el-table-column  prop="memo" label="备注" width="600px"></el-table-column>


        </el-table>
      </el-col>
    </el-row>
    <div class="block" align="center">
      <span class="demonstration"></span>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObject.pageCurrent"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="pageObject.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObject.rowCount">
      </el-pagination>
    </div>
  </div>

</template>

<script>

  import $api from "../api/axios";
  import storage from "../api/storage"

  export default {
    name: "MemoLog",
    data(){
      return{
        tid:'',
        pageObject: {
          pageCurrent: 1,
          rowCount: 0,
          pageSize: 100,
        },

        memoData:[],
        tbUser:{
          nick:'',
          subNick:'',
          appkey: '',
          sessionkey:''
        },
      }
    },
    methods:{
      indexMethod(index){
        return index+1;
      },
      //改变pageSize
      handleSizeChange: function (val) {
        this.pageObject.pageSize = val;
        this.getMemoLog();
      },
      //当前页面改变
      handleCurrentChange: function (val) {
        this.pageObject.pageCurrent = val;
        this.getMemoLog();
      },
      getMemoLog:function () {
        let param ={
          nick:storage.get("nick"),
          tid: this.tid,
          pageCurrent: this.pageObject.pageCurrent,
          rowCount: this.pageObject.rowCount,
          pageSize: this.pageObject.pageSize,
        };
        $api.post("/auto/d7k9h6ks8375hdhf", param, response => {  //d7k9h6ks8375hdhf   memo
          let dataResult = response.data;
          console.log(dataResult);
          if (dataResult.state == 1 && dataResult.message == "ok") {
            let memoData = dataResult.data.list;
            let pageObject = dataResult.data.pageObject;
            this.memoData = memoData;
            this.pageObject.rowCount = pageObject.rowCount;
            this.pageObject.pageSize = pageObject.pageSize;
          }else {
            this.$message.error(dataResult);
          }
        })

      }

    },
    mounted() {
      this.getMemoLog();
    }
  }
</script>

<style >
  a{
    color: #409EFF;
    text-decoration: none;
  }

</style>





// WEBPACK FOOTER //
// src/auto/MemoLog.vue